"use client";

import { useLocale, useTranslations } from "next-intl";
import React from "react";
import color from "../../styles/_helpers/branding.module.scss";
import { ApplicationType, ButtonSizeType, CoursePage } from "@into-discovery/browsewebshared";
import { usePathname } from "/navigation";
import { ICourseProps } from "/models/course/details/ICourseProps";
import { i18n } from "/i18n-config";
import { useApplyURL } from "../../hooks/use-apply-url";

type Props = {
  pageProps: ICourseProps;
};

export default function CourseDetailsProvider({ pageProps }: Props) {
  const locale = useLocale();
  const pagePath = usePathname();
  const translate = useTranslations(`Redirect`);
  const brandURL = `/${locale}/` as string;
  const applyURL = useApplyURL(pageProps?.data?.brandId, pageProps?.data?.id);
  const coursePageSettings = {
    applyURL,
    brandURL,
    buttonCopyColor: color.white,
    buttonSize: ButtonSizeType.Medium,
    backgroundColor: pageProps?.invertedTheme ? pageProps?.brandPrimaryColor : pageProps?.themeColor,
    hoverBackgroundColor: pageProps?.invertedTheme ? pageProps?.brandPrimaryColor : pageProps?.themeColor,
    activeBackgroundColor: pageProps?.invertedTheme ? pageProps?.brandPrimaryColor : pageProps?.themeColor,
    b2cFlag: true,
    redirectModal: {
      title: translate(`title`),
      message: translate(`message`),
      buttonText: translate(`buttonText`)
    }
  };

  return (
    <CoursePage
      courseContent={pageProps?.content}
      courseData={pageProps?.data}
      coursePageSettings={coursePageSettings}
      courseInstance={pageProps?.instances}
      pagePath={pagePath}
      locales={i18n.locales}
      application={ApplicationType.UniBrandedB2c}
      googleTagId={process.env.NEXT_PUBLIC_GTM_CONTAINER_ID}
      iCasUndergraduateExists={pageProps?.iCasUndergraduateExists}
      iCasGraduateExists={pageProps?.iCasGraduateExists}
      currentLocale={locale}
    />
  );
}
